
import { defineComponent } from 'vue';
import type { PropType } from 'vue';

export default defineComponent({
	name: 'ArticleTableOfContent',
	data() {
		return {
			hasH2s: this.toc.some(t => t.level === 1)
		};
	},
	methods: {
		scrollToLinkedArticles() {
			const element = document.querySelector('#linked-articles');
			element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
		},
		scrollToSection(id: string) {
			const element = document.querySelector(`#${id}`);
			element?.classList.add(this.$isMobile.any ? 'scroll-mt-3' : 'scroll-mt-40');
			element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	},
	props: {
		isCompanyPage: { type: Boolean },
		toc: { type: Array as PropType<{ id: string; level: number; text: string }[]>, required: true }
	}
});
